import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { CNConsultation } from 'src/app/models/cnconsultation';
import { TypeManagerService } from 'src/app/services/type-manager.service';
import { PrescriptionDialogComponent } from '../../prescription/prescription-dialog/prescription-dialog.component';

@ManageType('ContactEditDialogComponent')
@Component({
  selector: 'app-contact-edit-dialog',
  templateUrl: './contact-edit-dialog.component.html',
  styleUrls: ['./contact-edit-dialog.component.scss']
})
export class ContactEditDialogComponent implements OnInit {

  public contact: CNConsultation;

  constructor(private dialog: MatDialog, private dialogRef: MatDialogRef<PrescriptionDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    if (data && data.contact) {
      this.contact = data.contact;
    }
  }

  ngOnInit(): void {
  }

  close() {
    // Remove all added entry with id = 0
//    this.prescription.purgeChilds$('SNItem.CNItem.CNPrescriptionEntry');
    this.dialogRef.close();
  }

  save() {
    // Create or update prescription
//    this.prescriptions.updatePrescription(this.prescription).subscribe(updatedPrescription => {
      this.dialogRef.close(this.contact);
//    });
  }

}
